import SellWizard from "./components/wizard";
import style from "./styles.module.scss";

const Sell = () => {
  return (
    <section className={style.sellWizard}>
      <div className={style.sellWizard__container}>
        <SellWizard />
      </div>
    </section>
  );
};

export default Sell;
